<!--企业报表页面  -->
/* eslint-disable */
<template>
<div class="comReportDetails">
  <!--基础信息  -->
  <div class="modules">
    <div class="title">租客基础信息</div>
    <div class="bottom">
      <div class="bottom_line">
        <span class="line_title">租客名称</span>
        <span class="line_text">{{billInfo.merchantName}}</span>
      </div>
      <div class="bottom_line">
        <span class="line_title">合同编号</span>
        <span class="line_text">{{contNo}}</span>
      </div>
      <div class="bottom_line">
        <span class="line_title">项目名称</span>
        <span class="line_text">{{billInfo.projectName}}</span>
      </div>
      <div class="bottom_line">
        <span class="line_title">房源</span>
        <span class="line_text">{{billInfo.sapceNames}}</span>
      </div>
    </div>
  </div>
  <!--租客租期  -->
  <!--环状图  -->
  <div class="modules">
    <div class="title">租客租期</div>
    <div class="huanChart">
      <ve-ring class="ring" height="100%" width="100%" :data="chartData" :legend-visible="false" :tooltip-visible="false" :extend="chartExtend" :settings="chartSettings">
      </ve-ring>
      <div class="chart_t_wrap">
        <div class="chart_t1">剩余(天)</div>
        <div class="chart_t2">{{billInfo.overDays &lt; 0 ? billInfo.remainDays+billInfo.overDays:(billInfo.remainDays &lt; 0)?0:billInfo.remainDays}}</div>
        <div class="chart_t_line">
        </div>
        <div class="chart_t3">已用{{billInfo.overDays &lt; 0 ? 0:(billInfo.remainDays &lt; 0 ? (billInfo.overDays+billInfo.remainDays):billInfo.overDays)}}天</div>
      </div>
    </div>
    <div class="bottom">
      <div class="bottom_line" v-if="billInfo.remainDays">
        <span class="line_title">总共租期</span>
        <span class="line_text">{{billInfo.period}}</span>
      </div>
      <div class="bottom_line">
        <div class="bottom_line">
          <span class="line_title">开始日期</span>
          <span class="line_text">{{billInfo.startDate}}</span>
        </div>
        <div class="bottom_line">
          <span class="line_title">结束日期</span>
          <span class="line_text">{{billInfo.endDate}}</span>
        </div>
      </div>
    </div>
  </div>
  <!--缴费情况  -->
  <div class="modules">
    <div class="title">缴费情况</div>
    <!-- <div class="modules_title">
      <div class="modules_title_l">账单</div>
      <div class="modules_title_r">
        <div class="title_r_t"></div>
      </div>
    </div> -->
    <div class="bottom_mess">
      <div class="wait_p" v-if="billInfo.arrearsFeeAmount">
        <span class="p_left">欠款待缴账单</span>
        <span class="p_right">¥ {{billInfo.arrearsFeeAmount}}元</span>
      </div>
      <div class="bottom_item">
        <span class="line_title line_t">已缴租金</span>
        <span class="line_text">{{billInfo.fixedRentFeeAmount?billInfo.fixedRentFeeAmount:0}}元</span>
      </div>
      <div class="bottom_item">
        <span class="line_title">已缴物业费</span>
        <span class="line_text">{{billInfo.propertyFeeAmount?billInfo.propertyFeeAmount:0}}元</span>
      </div>
      <div class="bottom_item">
        <span class="line_title line_t">保证金</span>
        <span class="line_text">{{billInfo.bondFeeAmount?billInfo.bondFeeAmount:0}}元</span>
      </div>
      <div class="bottom_item">
        <span class="line_title">已缴水电费</span>
        <span class="line_text">{{billInfo.waterAndElectricityFeeAmount?billInfo.waterAndElectricityFeeAmount:0}}元</span>
      </div>
      <div class="bottom_item">
        <span class="line_title line_t">已缴其他费用</span>
        <span class="line_text">{{billInfo.otherFeeAmount?billInfo.otherFeeAmount:0}}元</span>
      </div>
    </div>
  </div>
  <!-- <div class="modules">
     <div class="title">商户贡献次数</div>
     <div class="bottom">
       <div class="bottom_line">
         <div class="bottom_line">
           <span class="line_title">报修次数</span>
           <span class="line_text">{{otherInfo.repairNum}}</span>
         </div>
         <div class="bottom_line">
           <span class="line_title">投诉次数</span>
           <span class="line_text">{{otherInfo.complaintNum}}</span>
         </div>
       </div>
     </div>
    </div> -->
  <!-- 能耗-电费 -->
  <div class="modules" v-if="barElectricBillBeans.length!=0">
    <div class="modules_title">
      <div class="modules_title_l">能耗-电费</div>
      <div class="modules_title_r" @click="billDetails(1)">
        <div class="title_r_t">明细</div>
        <img class="modules_title_r_i" :src="require('../../assets/images/icon_indicator_next.png')" alt="">
      </div>
    </div>
    <div class="modules2">
      <ve-histogram :extend="chartExtend_dian" height="217px" :legend-visible="false" :loading="loading" :settings="settings1" :data-empty="dataEmpty" width="100%" :data="chartDataColumns_dian"></ve-histogram>
    </div>
  </div>
  <!-- 能耗-水费 -->
  <div class="modules" v-if="barWaterBillBeans.length!=0">
    <div class="modules_title">
      <div class="modules_title_l">能耗-水费</div>
      <div class="modules_title_r" @click="billDetails(2)">
        <div class="title_r_t">明细</div>
        <img class="modules_title_r_i" :src="require('../../assets/images/icon_indicator_next.png')" alt="">
      </div>
    </div>
    <div class="modules2">
      <ve-histogram :extend="chartExtend_shui" height="217px" :legend-visible="false" :loading="loading" :settings="settings2" :data-empty="dataEmpty" width="100%" :data="chartDataColumns_shui"></ve-histogram>
    </div>
  </div>
</div>
</template>
<script>
import wx from 'weixin-js-sdk'
//import wx from 'jweixin-1.6.0'
import {
  getTenantReportByParam,callSpaceUp
} from '../../utils/api';
import {
  mapState
} from 'vuex';
export default {
  name: 'comReport',
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  data() {
    return {
      contractNo: "",
      arrears: {},
      billInfo: {},
      otherInfo: {},
      tenantInfo: {},
      contNo: '',
      // 环状图
      chartData: {
        columns: ['', 'value'],
        rows: [{
            '': '',
            'value': 0
          },
          {
            '': '',
            'value': 0
          },
        ]
      },
      chartExtend:{

      },
      // 柱状图
      loading: false,
      dataEmpty:false,
      chartDataColumns_dian: {
        columns: ['日期', '金额'],
        rows: []
      },
      chartDataColumns_shui: {
        columns: ['日期', '金额'],
        rows: []
      },
      /*
        电费柱状图配置参数
       */
      chartExtend_dian: {
        // 网格配置
        grid: {
          left: '0%',
          right: '0%',
          containLabel: true,
          top: '20%',
          bottom: '5%',
          backgroundColor: 'red'
          // borderColor:'#FFF'
        },
        // x轴配置
        xAxis: {
          axisPointer:{
            show:true,
            lineStyle:{
              color:'#FF9900'
            }
          },
          axisLabel: {
            textStyle: {
              color: '#999999',
              fontSize: 9
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#FFC978'
            }
          }
        },
        // y轴配置
        yAxis: {
          // nameGap:30,
          name: "单位(元)",
          nameTextStyle: {
            lineHeight: 30,
            color: '#999999'
          },
          axisLabel: {
            textStyle: {
              color: '#999999',
              fontSize: 9
            }
          },
          splitLine: {
            show: false
          },
          splitArea: {
            show: true,
            areaStyle: {
              color: ['#FFFFFF', '#FAFAFA']
            }
          },
          position: 'left',
          axisLine: {
            show: true,
            lineStyle: {
              color: '#fff'
            }
          },

        },
        // 柱体上面文字
        label: {
          color: '#666666',
          fontSize: 11
        },
        // 柱体配置
        series: {
          type: 'bar',
          barWidth: "18px",
          itemStyle: {
            normal: {
              color: '#FFC978'
            }
          },
          emphasis:{
            itemStyle:{
              color: '#FF9900'
            },
            label:{
              color:'#FF9900'
            }
          }
        }
      },
      /*
        电费柱状图设置
       */
      settings1: {
        // yAxisName: ['单位(元)'],
        // 柱图 -- 显示柱状图数据值，并把具体数字放在顶部
        label: {
          show: true,
          position: "top"
        },
        itemStyle: {
          color: '#FFC978'
        }
      },
      /*
        水费柱状图配置参数
       */
      chartExtend_shui: {
        grid: {
          left: '0%',
          right: '0%',
          containLabel: true,
          top: '20%',
          bottom: '5%'
        },
        xAxis: {
          axisPointer:{
            show:true,
            lineStyle:{
              color:'#0087FF'
            }
          },
          axisLabel: {
            textStyle: {
              color: '#999999',
              fontSize: 9
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#4BABFF'
            }
          }
        },
        yAxis: {
          name: '单位(元)',
          nameTextStyle: {
            lineHeight: 30,
            color: '#999999'
          },
          axisLabel: {
            textStyle: {
              color: '#999999',
              fontSize: 9
            }
          },
          splitLine: {
            show: false
          },
          splitArea: {
            show: true,
            areaStyle: {
              color: ['#FFFFFF', '#FAFAFA']
            }
          },
          position: 'left',
          axisLine: {
            show: true,
            lineStyle: {
              color: '#fff'
            }
          }
        },
        label: {
          color: '#666666',
          fontSize: 11
        },
        series: {
          type: 'bar',
          barWidth: "18px",
          itemStyle: {
            normal: {
              color: '#4BABFF'
            }
          },
          emphasis:{
            itemStyle:{
              color: '#0087FF'
            },
            label:{
              color:'#0087FF'
            }
          }
        }
      },
      /*
        水费柱状图配置设置
       */
      settings2: {
        // 柱图 -- 显示柱状图数据值，并把具体数字放在顶部
        label: {
          show: true,
          position: "top"
        },
        itemStyle: {
          color: '#4BABFF'
        }
      },
      /*
        电费数据
       */
      barElectricBillBeans:[],
      /*
        水费数据
       */
      barWaterBillBeans:[],
      /*
        明细数据
       */
      monthFeeBillBeans:[]
    };
  },
  created() {
    wx.ready(()=>{
      wx.hideOptionMenu()
      // wx.hideMenuItems({
      //   menuList: ["menuItem:share:timeline", "menuItem:copyUrl", "menuItem:share:appMessage", "menuItem:share:qq", "menuItem:share:weiboApp", "menuItem:favorite", "menuItem:share:facebook", "menuItem:share:QZone", "menuItem:editTag", "menuItem:delete", "menuItem:copyUrl", "menuItem:originPage", "menuItem:readMode", "menuItem:openWithQQBrowser", "menuItem:openWithSafari", "menuItem:share:email", "menuItem:share:brand"] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮
      // });
    })
    this.contractNo = this.$route.query.id
    this.contNo = this.$route.query.contNo
    this.getTenantReportByParam();
    this.getPropertyBill()
    this.chartExtend = {
      legend: {
        show: false
      }, //隐藏legend
      series: {
        silent: true, //饼图不响应鼠标事件
        center: ['50%', '50%']
      },
      itemStyle:{
        shadowBlur:14,
        shadowOffsetY:6,
        shadowOffsetX:0,
        shadowColor:'rgba(0,52,69,0.07)'
      }
    };
    this.chartSettings = {
      radius: ['80px', '94px'],
      label: {
        // itemStyle:{
        //   shadowBlur:16,
        //   shadowOffsetX:2,
        //   shadowColor:'rgba(241,243,244,1)'
        // },
        show: false,
        // formatter: params => {
        //   if (params.dataIndex === 0) {
        //     // return `{a| 通过率${params.percent}%}`
        //   } else {
        //     // return `{b| 未过率${params.percent}%}`
        //   }
        // },
        // rich: {
        //   a: {
        //     color: '#438de7'
        //   },
        //   b: {
        //     color: '#7b7d86'
        //   }
        // }
      },
      itemStyle: {
        color: seriesIndex => {
          if (seriesIndex.dataIndex === 0) {
            return {
              type: 'linear',
              x: 0,
              y: 1,
              x2: 0,
              y2: 0,
              colorStops: [{
                  offset: 0,
                  color: 'rgba(23, 64, 218, 1)' // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: 'rgba(23, 64, 218, 1)' // 100% 处的颜色
                },
                {
                  offset: 1,
                  color: 'rgba(23, 64, 218, 1)' // 100% 处的颜色
                },
                {
                  offset: 1,
                  color: 'rgba(23, 64, 218, 1)' // 100% 处的颜色
                }
              ],
              global: false // 缺省为 false
            };
          } else {
            return '#E8EEF0';
          }
        }
      }
    }
  },
  methods: {
    /*
      明细
     */
    billDetails(type) {
      let self = this;
      this.$router.push(`/billDetails?id=${self.contractNo}&contNo=${self.contNo}&type=${type}`);
    },
    /*
      合同水电详情
     */
    getPropertyBill() {
      let parmes = {
        contId:Number(this.contractNo),
        year:"",
        url: '/property/rstRepair/getPropertyBill'
      }
      callSpaceUp(parmes).then(res => {
        console.log("合同水电详情");
        console.log(res);
        if (res.res.code == 10000) {
          this.barElectricBillBeans = res.body.data.barElectricBillBeans?res.body.data.barElectricBillBeans.reverse():[]
          this.barWaterBillBeans = res.body.data.barWaterBillBeans?res.body.data.barWaterBillBeans.reverse():[]
          this.monthFeeBillBeans = res.body.data.monthFeeBillBeans?res.body.data.monthFeeBillBeans.reverse():[]

          let arr = [];
          for(let i=0;i<this.barElectricBillBeans.length;i++){
             arr.push({
               '日期':this.barElectricBillBeans[i].month+'月',
               '金额': this.barElectricBillBeans[i].feeAmount
             })
          }
          arr = arr.length ? arr : [{'日期':'1月','金额':'0'},{'日期':'2月','金额':'0'},{'日期':'3月','金额':'0'},{'日期':'4月','金额':'0'},{'日期':'5月','金额':'0'},{'日期':'6月','金额':'0'}]
          this.chartDataColumns_dian =  {
            columns: ['日期', '金额'],
            rows: arr
          }

          let arr2 = []
          for(let i=0;i<this.barWaterBillBeans.length;i++){
             arr2.push({
               '日期':this.barWaterBillBeans[i].month+'月',
               '金额': this.barWaterBillBeans[i].feeAmount
             })
          }
          arr2 = arr2.length ? arr2 : [{'日期':'1月','金额':'0'},{'日期':'2月','金额':'0'},{'日期':'3月','金额':'0'},{'日期':'4月','金额':'0'},{'日期':'5月','金额':'0'},{'日期':'6月','金额':'0'}]
          this.chartDataColumns_shui = {
            columns: ['日期', '金额'],
            rows: arr2
          }
        }
      });
    },
    getTenantReportByParam() {
      let params = {
        userId: this.common.userId,
        contractNo: this.$route.query.id
      };
      getTenantReportByParam(params, {
        userId: this.common.userId,
        openId: this.common.openId
      }).then(res => {
        console.log('企业报表详情');
        console.log(res);
        this.billInfo = res.body.billInfo
        this.otherInfo = res.body.otherInfo
        this.chartData = {
          columns: ['', 'value'],
          rows: [{
              '': '',
              'value': this.billInfo.remainDays
            },
            {
              '': '',
              'value': this.billInfo.overDays
            },
          ]
        }
      });
    },
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.comReportDetails {
    background: rgba(255, 255, 255, 1);
    .modules2{
      width:750px;
      padding: 0 40px;
      box-sizing: border-box;
    }
    .modules {
        display: flex;
        flex-direction: column;
        align-items: center;
        .modules_title {
            height: 88px;
            width: 722px;
            display: flex;
            margin-left: 28px;
            box-sizing: border-box;
            align-items: center;
            padding-right: 20px;
            border-bottom: 1px solid #EAEAEA;
            .modules_title_l {
                height: 40px;
                font-size: 28px;
                color: rgba(51,51,51,1);
                line-height: 40px;
            }
            .modules_title_r {
                flex: 1;
                height: 34px;
                font-size: 24px;
                color: rgba(153,153,153,1);
                line-height: 34px;
                text-align: right;
                display: flex;
                align-items: center;
                justify-content: flex-end;
            }
            .title_r_t {
                height: 34px;
                font-size: 24px;
                color: rgba(153,153,153,1);
                line-height: 38px;
            }
            .modules_title_r_i {
                width: 32px;
                height: 32px;
                margin: 1px 0 1px 4px;
            }
        }
        .huanChart {
            width: 540px;
            height: 540px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            margin: 4px 0 0px;
            position: relative;
            .chart_t_wrap {
                position: absolute;
                display: flex;
                flex-direction: column;
                align-items: center;
                top: 50%;
                left: 50%;
                transform: translate(-50%,-50%);
                .chart_t1 {
                    height: 34px;
                    font-size: 24px;
                    color: rgba(102,102,102,1);
                    line-height: 34px;
                }

                .chart_t2 {
                    font-size: 80px;
                    height: 112px;
                    font-weight: 500;
                    color: rgba(23,64,218,1);
                    line-height: 112px;
                    margin-bottom: 6px;
                }
                .chart_t_line {
                    width: 144px;
                    height: 2px;
                    background: rgba(232,238,240,1);
                    margin-bottom: 18px;
                }
                .chart_t3 {
                    height: 34px;
                    font-size: 24px;

                    color: rgba(201,211,214,1);
                    line-height: 34px;
                }
            }
        }
        .title {
            width: 100%;
            height: 68px;
            background: rgba(248,248,248,1);
            font-size: 26px;

            color: rgba(153,153,153,1);
            line-height: 36px;
            padding: 16px 28px;
            box-sizing: border-box;
        }
        .bottom {
            width: 100%;
            padding: 28px 28px 0;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            .bottom_line {
                // height: 28px;
                margin-bottom: 20px;
                display: flex;
                flex: 1;
                width: 100%;
                .flex();
                .line_title {
                    display: block;
                    font-size: 24px;
                    color: rgba(153,153,153,1);
                    line-height: 28px;
                    width: 148px;
                }
                .line_text {
                    // height:28px;
                    flex: 1;
                    font-size: 24px;
                    color: rgba(51,51,51,1);
                    line-height: 28px;
                }
            }
        }
    }
}
.ring {
    width: 400px;
    height: 400px;
    z-index: 10;
    position: fixed;
}
.bottom_mess {
    padding: 28px;
    .flex();
    .wait_p {
        width: 100%;
        margin-bottom: 28px;
        .flex();
        justify-content: space-between;
        height: 88px;
        align-items: center;
        .borderB();
        .p_left {
            font-size: 28px;
            color: rgba(51,51,51,1);
        }
        .p_right {
            font-size: 28px;
            color: rgba(252,63,86,1);
        }
    }
    .bottom_item {
        width: 50%;
        height: 28px;
        .flex();
        align-items: center;
        margin-bottom: 24px;
        .line_title {
            display: block;
            font-size: 24px;
            color: rgba(153,153,153,1);
            line-height: 28px;
            width: 148px;
        }
        .line_text {
            height: 28px;
            font-size: 24px;
            color: rgba(51,51,51,1);
            line-height: 28px;
        }
        .line_t {
            width: 172px;
        }
    }
}
</style>
